// extracted by mini-css-extract-plugin
module.exports = {"css-editor":"widget-custom_css-editor__35zhv","footer-button-container":"widget-custom_footer-button-container__3ChxB","css-editor-title":"widget-custom_css-editor-title__Fim1T"};